import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const programsData: NavItem[] = [
  {
    label: 'About',
    to: '/pages/programs/about'
  },
  {
    label: 'Documentation',
    to: '/pages/programs/documentation'
  },
  {
    label: 'Terms',
    to: '/pages/programs/terms'
  },
  {
    label: 'Process',
    to: '/pages/programs/process'
  },
  {
    label: 'Stats',
    to: '/pages/programs/stats'
  }
];
